<template>
  <generic-modal :title="$t('profile')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("username") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.settings.api_username"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("password") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.settings.api_password"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-lock"></i>
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("api url for token") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.settings.url_api_token"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <label class="label">{{ $t("api url for query") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.settings.url_api_query"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div>
      <div class="field">
        <label class="label">{{ $t("api url for verification") }}</label>
        <p class="control is-expanded has-icons-left">
          <input
            type="text"
            class="input"
            v-model="meta.settings.url_api_verification"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-server"></i>
          </span>
        </p>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  get,
  change_active_tab,
  generate_error_message_text,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProfileModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name ||
        !v.meta.settings.api_username ||
        !v.meta.settings.api_password ||
        !v.meta.settings.url_api_token ||
        !v.meta.settings.url_api_query
      );
    },
  },
  methods: {
    change_active_tab,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(profile_uuid) {
      let v = this;
      v.set_initial_state();
      get("/renap/profile", { uuid: profile_uuid })
        .then((profile) => {
          if (profile.settings && !profile.settings.verification_reports)
            profile.settings.verification_reports = [];

          v.meta = profile;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      if (profile.uuid) {
        post("/renap/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      } else {
        put("/renap/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {});
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
